import '../styles/Services.css';

const SERVICES = [
  { icon: 'paid', title: 'Pagos semanales y quincenales', text: 'Cobros puntuales y claridad en tus números.' },
  { icon: 'live_tv', title: 'Entrenamiento en vivo', text: 'Acompañamiento en tiempo real para mejorar.' },
  { icon: 'support_agent', title: 'Soporte técnico remoto', text: 'Te ayudamos a resolver y optimizar tu set.' },
  { icon: 'photo_camera', title: 'Fotografías profesionales', text: 'Imagen y contenido visual de alto nivel.' },
  { icon: 'share', title: 'Apoyo en redes sociales', text: 'Estrategia y guía para crecer tu presencia.' },
  { icon: 'account_balance_wallet', title: 'Varios métodos de pago', text: 'Cuenta bancaria, Paxum, Skril y más.' },
  { icon: 'insights', title: 'Estrategias de posicionamiento', text: 'Visibilidad, retención y mejores resultados.' },
  { icon: 'school', title: 'Master class', text: 'Formación continua para escalar tu rendimiento.' },
];

function Services() {
  return (
    <section id="servicios" className="tm-section tm-services-section" aria-labelledby="services-title">
      <div className="tm-container">
        <header className="tm-services-header">
          <h2 id="services-title" className="tm-services-title">Servicios</h2>
          <p className="tm-services-subtitle">
            Beneficios pensados para potenciar tu carrera, con soporte y estrategia en cada etapa.
          </p>
        </header>

        <div className="tm-services-grid" role="list">
          {SERVICES.map((service, idx) => (
            <article
              key={service.title}
              className={`tm-services-card ${idx === 6 ? 'tm-services-card--featured' : ''}`}
              role="listitem"
              tabIndex={0}
            >
              <div className="tm-services-icon" aria-hidden="true">
                <span className="material-symbols-outlined tm-services-icon-symbol">{service.icon}</span>
              </div>
              <h3 className="tm-services-card-title">{service.title}</h3>
              <p className="tm-services-card-text">{service.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;

